import React from 'react'
import { Typography, Chip, Grid, Tooltip } from '@the-platform-group/component-library'
import { HelpOutline as HelpOutlineIcon } from '@the-platform-group/component-library/Icons'
import { getJobTitleAndOrgName } from 'pages/MergeProfiles/utils'

const AffiliationsTooltip = ({ jobPreview }) => {
  const { activityCount = 0, surveyResponseCount = 0, customerFavoritePeopleCount = 0 } = jobPreview

  return (
    <Typography variant="caption" display="block" sx={{ whiteSpace: 'pre-line' }}>
      {`Activities: ${activityCount}\nResponses: ${surveyResponseCount}\nKey Contacts: ${customerFavoritePeopleCount}`}
    </Typography>
  )
}

const JobLabel = ({ job, jobPreview }) => (
  <Grid container>
    <Grid item container alignItems="center" spacing={1}>
      <Grid item>
        <Typography variant="body2">{getJobTitleAndOrgName(job)}</Typography>
      </Grid>
      {job.isPrimary && (
        <Grid item>
          <Chip label="Primary" variant="outlined" color="primary" size="x-small" />
        </Grid>
      )}
    </Grid>
    {jobPreview && (
      <Grid item xs={12} container alignItems="center" spacing={0.5}>
        <Grid item>
          <Typography variant="caption" color="primary">
            Affiliations: {calculateJobAffiliations(jobPreview)}
          </Typography>
        </Grid>
        <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
          <Tooltip title={<AffiliationsTooltip jobPreview={jobPreview} />} placement="top">
            <HelpOutlineIcon fontSize="x-small" />
          </Tooltip>
        </Grid>
      </Grid>
    )}
  </Grid>
)

const calculateJobAffiliations = jobPreview => {
  const { activityCount = 0, customerFavoritePeopleCount = 0, surveyResponseCount = 0 } = jobPreview

  return activityCount + customerFavoritePeopleCount + surveyResponseCount
}

export default JobLabel
